// system routes (not-found) — ungated beyond privateMiddleware.
export const systemLoader = () => null;
